<template>
  <div
    class="modal fade registrationWarning-modal"
    tabindex="-1"
    aria-labelledby="registrationWarningModalLabel"
    aria-hidden="true"
    ref="registrationWarningModal"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          ></button>
        </div>
        <div class="modal-body">
          <h5 class="modal-title">Бесплатный промо-доступ</h5>
          <form class="my-4">
            <div class="mb-3">
              <label for="username" class="form-label"
                >Промо-период для новых пользователей 5 проверок в месяц +
                доступ к B2B-платформе после регистрации.</label
              >
            </div>
            <button
              type="button"
              class="btn btn-primary w-100"
              @click="goToRegistration"
            >
              Зарегистрироваться
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "RegistrationWarningModal",
  setup() {
    const router = useRouter();
    const registrationWarningModal = ref(null);
    let modalInstance = null;

    const unlockBodyScroll = () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      document.body.classList.remove("modal-open");
    };

    const openModal = () => {
      if (modalInstance) {
        modalInstance.show();
      }
    };

    const goToRegistration = () => {
      router.push("/login");
      if (modalInstance) modalInstance.hide();
    };

    const onShown = () => {
      unlockBodyScroll();
    };

    onMounted(() => {
      if (registrationWarningModal.value) {
        modalInstance = Modal.getOrCreateInstance(
          registrationWarningModal.value
        );
        registrationWarningModal.value.addEventListener(
          "shown.bs.modal",
          onShown
        );
      } else {
        console.error("Модальное окно не найдено");
      }
    });

    onBeforeUnmount(() => {
      if (registrationWarningModal.value) {
        registrationWarningModal.value.removeEventListener(
          "shown.bs.modal",
          onShown
        );
      }
    });

    return {
      openModal,
      registrationWarningModal,
      goToRegistration,
    };
  },
});
</script>

<style lang="scss">
.registrationWarning-modal {
  transition: opacity 0.35s ease;
  .modal-dialog {
    transition: transform 0.35s ease, opacity 0.35s ease;
    transform: translateY(14px) scale(0.98);
    opacity: 0;
    .modal-content {
      border: none;
      .modal-header {
        border-bottom: 0;
        padding: 2rem 2rem 1rem 2rem;
      }
      .modal-body {
        color: #3e3e3e;
        padding: 0.5rem 2rem 2rem 2rem;
        .modal-title {
          font-size: 20px;
          font-weight: 700;
        }
        form {
          label {
            font-size: 20px;
            font-weight: 400;
          }
        }
        button {
          min-width: 7rem;
        }
      }
    }
  }
  &.show {
    .modal-dialog {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }
}
</style>
